import { plural, t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'
import { TextThemeUI } from '@jotta/ui/themeui'

export interface HidePhotoDialogProps extends RadixModalProps {
  count?: number
  isLoading?: boolean
  onHidePhoto: () => void
}

export const HidePhotoDialog: React.FC<HidePhotoDialogProps> = ({
  count = 1,
  open = false,
  isLoading = false,
  onClose,
  onHidePhoto,
  ...props
}) => {
  return (
    <RadixModal open={open} onClose={onClose} {...props}>
      <RadixDialog
        title={plural(count, {
          one: 'Are you sure you want to hide the selected photo?',
          other: 'Are you sure you want to hide the # selected photos?',
        })}
        onClose={onClose}
        buttons={[
          {
            label: plural(count, {
              one: 'Yes, hide photo',
              other: 'Yes, hide photos',
            }),
            loading: isLoading,
            action: onHidePhoto,
            type: 'destructive',
          },
          {
            action: 'close',
            label: t`Cancel`,
            type: 'outline',
          },
        ]}
      >
        <TextThemeUI variant="styles.p" sx={{ mb: 3 }}>
          <Trans>
            You can restore photos from “Hidden photos” in your user menu.
          </Trans>
        </TextThemeUI>
      </RadixDialog>
    </RadixModal>
  )
}
